// import Cookies from '@js-cookie'

$(document).ready(function () {

    let cookieBar = $('div.cookie-bar')

    const COOKIE_NAME = 'CookieAllowed'

    if (typeof Cookies !== "undefined") {

        let cookieAllowed = Cookies.get(COOKIE_NAME)

        if (cookieAllowed != 1) {
            cookieBar.slideUp().show('fast')
        }

        $('#CookieAccept').click(function () {
            Cookies.set(COOKIE_NAME, 1, { expires: 365 })
            cookieBar.slideDown().hide('fast')
        })
    }

});